/**
 *
 * 应用配置
 *
 * @Author: Shann
 * @LastEditors: Shann
 * @Date: 2021-04-08 18:01:28
 * @LastEditTime: 2021-04-19 14:58:27
 * @FilePath: \buyer-one\dop-webapp\config\config.js
 * @Copyright: Copyright 2021-2021 ESSA. all rights reserved.
 */

module.exports = {
    /**
     * 环境配置
     */
    environment: "production",

    /**
     * 服务器资料
     */
    servers: {
        hotfix: {
            ip: "192.168.1.19",
            api: "http://192.168.1.19:8080/",
        },
        sit: {
            ip: "192.168.1.247",
            api: "http://192.168.1.247:8080/",
            mgApi: "http://192.168.1.247:8480/bportal/",
        },
        uat: {
            ip: "112.74.135.97",
            api: "http://112.74.135.97:8080/",
            mgApi: "https://bportal-api.essatoy.com",
            exportApi: "http://bpms.spstoys.com:7291",
        },
         production: {
            ip: "10.25.138.201",
            api: "https://service-api.essa.cn",
            mgApi: "https://bportal-api.essa.cn",
            exportApi: "http://report.essazhineng.com:969",
	    bpmsUrl: "https://www.essa123.com",	
            fileBankApi: "https://file-api.essa.cn",
            portalUrl:'https://ru.essaone.com',
        },
    },

   essaone:{
        zh:"https://cn.essaone.com",
        en:"https://en.essaone.com",
        ru:"https://www.essaone.com",
    }



};
